// getPackageFromOfferByKey finds and returns the object for the package
// model from a given offer detail by the package's `uniqueKey`
export default function getPackageFromOfferByKey(
  offerDetails: App.Offer,
  uniqueKey: string,
) {
  return offerDetails.packages.find(pkg => pkg.uniqueKey == uniqueKey)
}
